import React from 'react'
import { Typography } from '@material-ui/core'

import { StepEditPanelProps } from '../pipelineBuilder.types'

export const DefaultStepPanel: React.FC<StepEditPanelProps> = () => {
    return (
        <Typography variant="body2" color="textSecondary">
            No additional settings for this step yet.
        </Typography>
    )
}
